module.exports = __webpack_public_path__ + "img/source05_06.296b102f.png";